import React from 'react';
import PropTypes from 'prop-types';
import { AddIcon, DetailsIcon } from 'utils/icons';
import AddItem from 'components/AddItem';

const AddItemSection = ({
  showAddItemInput,
  hasEditAccess,
  hasDetailsSheet,
  swimlaneIndex,
  swimlaneItems,
  addItemSuggestions,
  onAddItemClick,
  onAddItem,
  onAddDetailedView,
  onAddTopLevelSection,
  selectedItem,
}) => {
  if (!hasEditAccess()) {
    return null;
  }

  return (
    <div className="swimlane-item swimlane-item--action">
      {showAddItemInput ? (
        <div className="swimlane-item swimlane-item--add-input">
          <AddItem handleAddItem={onAddItem} options={addItemSuggestions} />
        </div>
      ) : (
        <>
          {!hasDetailsSheet && (
            <div
              tabIndex="1"
              className="action-add-item"
              id={`add-category-${swimlaneIndex}`}
              onClick={onAddItemClick}
            >
              Add Category <AddIcon className="action-add-item__icon" />
            </div>
          )}
          {swimlaneIndex === 0 && onAddTopLevelSection && (
            <div
              tabIndex="1"
              className="action-add-section"
              id={`add-section-${swimlaneIndex}`}
              onClick={onAddTopLevelSection}
            >
              Add Section <AddIcon className="action-add-section__icon" />
            </div>
          )}
          {swimlaneIndex > 0 && !swimlaneItems?.length && (
            <div
              className="action-add-details"
              onClick={onAddDetailedView(swimlaneIndex - 1, selectedItem)}
            >
              {hasDetailsSheet ? 'View' : 'Add'} Details{' '}
              <DetailsIcon className="action-add-details__icon" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

AddItemSection.propTypes = {
  showAddItemInput: PropTypes.bool.isRequired,
  hasEditAccess: PropTypes.func.isRequired,
  hasDetailsSheet: PropTypes.bool.isRequired,
  swimlaneIndex: PropTypes.number.isRequired,
  swimlaneItems: PropTypes.array.isRequired,
  addItemSuggestions: PropTypes.array,
  onAddItemClick: PropTypes.func.isRequired,
  onAddItem: PropTypes.func.isRequired,
  onAddDetailedView: PropTypes.func.isRequired,
  onAddTopLevelSection: PropTypes.func,
  selectedItem: PropTypes.object,
};

AddItemSection.defaultProps = {
  addItemSuggestions: null,
  onAddTopLevelSection: null,
  selectedItem: {},
};

export default AddItemSection;
